import { classNamesFunction } from '@fluentui/react';
import * as React from 'react';
import { getShimmerAnimationStyles } from './shimmer-loading-animation.styles';
export const ShimmerLoadingAnimationBase = (props) => {
    const { theme } = props;
    const getClassNames = classNamesFunction();
    const classNames = getClassNames(getShimmerAnimationStyles, { theme: theme });
    return (
    // tslint:disable: jsx-ban-props
    React.createElement("svg", { className: classNames.root, viewBox: "0 0 100 100" },
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: "shimmerLoadingGradient", gradientTransform: "rotate(3)" },
                React.createElement("stop", { offset: "0%", stopColor: theme.palette.neutralTertiaryAlt }),
                React.createElement("stop", { offset: "50%", stopColor: theme.palette.neutralQuaternary }),
                React.createElement("stop", { offset: "100%", stopColor: theme.palette.neutralTertiaryAlt })),
            React.createElement("mask", { id: "shimmerMask" },
                React.createElement("rect", { x: "0", y: "0", className: classNames.mask }),
                React.createElement("rect", { x: "0", y: "40", className: classNames.mask }),
                React.createElement("rect", { x: "0", y: "80", className: classNames.mask }))),
        React.createElement("rect", { className: classNames.maskRect, mask: "url(#shimmerMask)" }),
        React.createElement("rect", { className: classNames.loadingBar, fill: "url(#shimmerLoadingGradient)", mask: "url(#shimmerMask)" })));
};
//# sourceMappingURL=shimmer-loading-animation.base.js.map